export class LatLngModel {
  readonly lat: number;
  readonly lng: number;

  constructor(latitude: number, longitude: number) {
    this.lat = latitude;
    this.lng = longitude;
  }
}
